// extracted by mini-css-extract-plugin
module.exports = {"navigationItem":"NavigationItem_navigationItem__Kb5_6"};